export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const bm = editor.BlockManager;
    
    const TYPE = DOMC.getType('C-SELECT');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            tagName:"SELECT",
            attributes:{
                'data-slg-type':'C-SELECT-YEAR',
                name:"year",
                placeholder:'Year'
            },
            classes:['form-control'],
            options:[],
             
          
        },
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-SELECT-YEAR")
                    return { type:'C-SELECT-YEAR' }
        }
    });

    var view = VIEW.extend({
        
    });

    DOMC.addType('C-SELECT-YEAR', {
        model:model,
        view:view,
    });

    /* bm.add('B-SELECT-YEAR', {
        label: `
                <p class="b-text-label mt-3">YEAR</p>
              `,
        content: { 
          type: 'C-SELECT-YEAR',
         },
        // media: '<svg>...</svg>',
    }); */
};
  